import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useRef, useEffect, useMemo, useCallback } from 'react';
import { useInput } from '@indriver/nova-core';
import { useComponentId } from '@indriver/whisperwind';
import { Box, Prefix, InputElement, FloatingContainer, FloatingLabel, Postfix } from './input.styles.js';
import { FormField } from '../form-field/form-field.js';

var _excluded = ["label", "hint"],
    _excluded2 = ["name", "type", "design", "handleChange", "handleFocus", "handleBlur", "disabled", "placeholder", "prefix", "postfix", "invalid", "value", "boxRef", "focused", "className", "handleClickOnBox", "required", "defaultValue", "style", "dir"];
var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
      hint = _ref.hint,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var inputRef = useRef(null);

  var _useInput = useInput(props, inputRef),
      name = _useInput.name,
      _useInput$type = _useInput.type,
      type = _useInput$type === void 0 ? 'text' : _useInput$type,
      _useInput$design = _useInput.design,
      design = _useInput$design === void 0 ? 'standart' : _useInput$design,
      handleChange = _useInput.handleChange,
      handleFocus = _useInput.handleFocus,
      handleBlur = _useInput.handleBlur,
      _useInput$disabled = _useInput.disabled,
      disabled = _useInput$disabled === void 0 ? false : _useInput$disabled,
      placeholder = _useInput.placeholder,
      prefix = _useInput.prefix,
      postfix = _useInput.postfix,
      _useInput$invalid = _useInput.invalid,
      invalid = _useInput$invalid === void 0 ? false : _useInput$invalid,
      value = _useInput.value,
      boxRef = _useInput.boxRef,
      focused = _useInput.focused,
      className = _useInput.className,
      handleClickOnBox = _useInput.handleClickOnBox,
      _useInput$required = _useInput.required,
      required = _useInput$required === void 0 ? false : _useInput$required,
      defaultValue = _useInput.defaultValue,
      style = _useInput.style,
      _useInput$dir = _useInput.dir,
      dir = _useInput$dir === void 0 ? 'ltr' : _useInput$dir,
      attrs = _objectWithoutPropertiesLoose(_useInput, _excluded2);

  useEffect(function () {
    if (!ref) {
      return;
    }

    if (typeof ref === 'function') {
      ref(inputRef.current);
    } else {
      // @ts-ignore:next-line
      ref.current = inputRef.current;
    }
  }, [ref]);
  var hintId = useComponentId({
    prefix: 'input'
  });
  var floatingState = useMemo(function () {
    if (prefix && postfix) {
      return 'both';
    }

    if (prefix && !postfix) {
      return 'prefixed';
    }

    if (!prefix && postfix) {
      return 'postfixed';
    }

    return 'default';
  }, [prefix, postfix]);
  var inputHasValue = useCallback(function () {
    var _inputRef$current;

    return Boolean(value != null ? value : inputRef == null ? void 0 : (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value);
  }, [value]);
  var floating = useMemo(function () {
    if (design === 'standart') {
      return false;
    }

    if (focused) {
      return true;
    }

    return false;
  }, [focused, design]);
  var floatingLabel = label != null ? label : placeholder;
  var shouldHighlightPrefix = focused || !!value || !!defaultValue;
  return /*#__PURE__*/React__default.createElement(FormField, {
    label: design === 'standart' ? label : undefined,
    hint: hint,
    hintId: hintId,
    htmlFor: attrs.id,
    required: required,
    disabled: disabled,
    dir: dir,
    invalid: invalid
  }, /*#__PURE__*/React__default.createElement(Box, {
    focused: focused,
    disabled: disabled,
    invalid: invalid,
    style: style,
    className: className,
    design: design,
    ref: boxRef,
    onClick: handleClickOnBox
  }, prefix && /*#__PURE__*/React__default.createElement(Prefix, {
    focused: shouldHighlightPrefix
  }, prefix), /*#__PURE__*/React__default.createElement(InputElement, _extends({
    "aria-invalid": invalid,
    "aria-required": required,
    "aria-disabled": disabled,
    design: design,
    placeholder: design === 'standart' ? placeholder : undefined
  }, attrs, {
    type: type,
    name: name,
    value: value,
    disabled: disabled,
    ref: inputRef,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  })), design === 'floating' ? /*#__PURE__*/React__default.createElement(FloatingContainer, {
    dir: dir,
    state: floatingState
  }, /*#__PURE__*/React__default.createElement(FloatingLabel, {
    floating: floating || inputHasValue(),
    htmlFor: attrs.id,
    dir: dir
  }, floatingLabel)) : null, postfix && /*#__PURE__*/React__default.createElement(Postfix, {
    focused: focused
  }, postfix)));
});

export { Input };
